import {Account} from "./account";

export interface Supplier {
  account: Account;
}
